<template>
  <div class="contact-notif-picker" :class="{ 'contact-notif-picker--compact': compact }">
    <label v-if="showLabel" class="form-label fw-bold fs-6 mb-3">{{ $t("Notifications") }}</label>
    <div v-if="loading" class="text-muted fs-7">{{ $t("Chargement...") }}</div>
    <div v-else-if="types.length === 0" class="text-muted fs-7">{{ $t("Aucune notification disponible") }}</div>
    <div v-else class="d-flex flex-column gap-2">
      <div
        v-for="type in types"
        :key="type.tnc_code"
        class="form-check form-check-sm form-check-custom form-check-solid"
      >
        <input
          :id="inputId(type.tnc_code)"
          class="form-check-input"
          type="checkbox"
          :value="type.tnc_code"
          :checked="isSelected(type.tnc_code)"
          :disabled="disabled"
          @change="toggleType(type.tnc_code, $event)"
        />
        <label class="form-check-label" :for="inputId(type.tnc_code)">
          {{ type.tnc_libelle || type.tnc_code }}
        </label>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import mAxiosApi from "@/api";

export interface NotifType {
  tnc_seq: number;
  tnc_code: string;
  tnc_libelle: string;
}

let pickerUid = 0;

export default defineComponent({
  name: "contact-notif-picker",
  props: {
    modelValue: {
      type: Array as () => string[],
      default: () => [],
    },
    defaultCodes: {
      type: Array as () => string[],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const uid = ++pickerUid;
    const loading = ref(true);
    const types = ref<NotifType[]>([]);

    const inputId = (code: string) => `contact-notif-${uid}-${code}`;

    const isSelected = (code: string) => props.modelValue.includes(code);

    const emitSelection = (codes: string[]) => {
      emit("update:modelValue", [...new Set(codes)]);
    };

    const toggleType = (code: string, event: Event) => {
      const checked = (event.target as HTMLInputElement).checked;
      if (checked) {
        emitSelection([...props.modelValue, code]);
      } else {
        emitSelection(props.modelValue.filter((c) => c !== code));
      }
    };
    // mounted
    onMounted(async () => {
      try {
        const res = await mAxiosApi.prototype.getAxios("/getNotifTypes");
        types.value = res.results || [];
        const available = new Set(types.value.map((t) => t.tnc_code));
        if (props.modelValue.length === 0 && props.defaultCodes.length > 0) {
          const defaults = props.defaultCodes.filter((c) => available.has(c));
          if (defaults.length > 0) {
            emitSelection(defaults);
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    });

    return {
      loading,
      types,
      inputId,
      isSelected,
      toggleType,
    };
  },
});
</script>

<style scoped>
.contact-notif-picker--compact .form-check-label {
  font-size: 0.9rem;
}
</style>
